module.exports = __webpack_public_path__ + "img/sq5d_banner.73ff6bc4.jpg";